import EventEmitter from 'events';

import Analytics from '../tools/analytics';
import Api from '../tools/api';
import Facebook from '../tools/facebook';
import util from '../tools/util';

export default {
  once,
  addChangeListener,
  removeChangeListener,
  init,
  isReady,
  isLoggedIn,
  getPlayerData,
  login,
  loginWithToken,
  logout,
  get,
  post,
  del,
};

const SESSION_KEY = process.env.SHORT_NAME + '_SESSION_KEY';
const HARBOUR_GAME_ID = process.env.HARBOUR_GAME_ID;

let g_ready = false;
let g_sessionKey = null;
let g_isLoggedIn = false;
let g_playerData = null;

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function once(callback) {
  g_eventEmitter.once(CHANGE_EVENT, callback);
}
function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}

function init(done) {
  if (!g_ready) {
    g_ready = true;
    g_sessionKey = window.localStorage[SESSION_KEY];
    if (g_sessionKey) {
      _verifySessionKey(err => {
        if (!err) {
          g_isLoggedIn = true;
          _emit('user_login');
        }
        done();
      });
    } else {
      done();
    }
  } else {
    done();
  }
}

function isReady() {
  return g_ready;
}
function isLoggedIn() {
  return g_isLoggedIn;
}
function getPlayerData() {
  return g_playerData;
}

function logout(done = null) {
  g_isLoggedIn = false;
  g_sessionKey = null;
  window.localStorage[SESSION_KEY] = '';
  _emit('logout');
  done && done();
}

function _verifySessionKey(done) {
  const opts = {
    url: '/client/1/player/check_session',
    query: {
      player_details: 'social',
      player_session_key: g_sessionKey,
    },
  };
  Api.get(opts, (err, body) => {
    if (err) {
      util.errorLog('UserStore._verifySessionKey: http err:', err, body);
      g_sessionKey = null;
      window.localStorage[SESSION_KEY] = '';
    } else if (body) {
      const { player_session_key, ...other } = body;
      if (player_session_key) {
        g_sessionKey = player_session_key;
        window.localStorage[SESSION_KEY] = player_session_key;
      }
      g_playerData = other;
    } else {
      err = 'bad_data';
    }
    done(err);
  });
}

function login(done) {
  Facebook.login((err, fb_info) => {
    if (err) {
      done(err);
    } else {
      _loginInternal(fb_info, done);
    }
  });
}
function loginWithToken(access_token, done) {
  Facebook.loginWithToken(access_token, (err, fb_info) => {
    if (err) {
      done(err);
    } else {
      _loginInternal(fb_info, done);
    }
  });
}

function _loginInternal(fb_info, done) {
  const opts = {
    url: '/client/1/player/current',
    body: {
      game_id: HARBOUR_GAME_ID,
      fb_app_id: process.env.WEB_FB_APP_ID,
      access_token: fb_info.access_token,
      name: fb_info.name,
      photo_url: fb_info.photo_url,
      player_details: 'social',
    },
    force_text: true,
  };
  Api.post(opts, (err, body) => {
    if (err) {
      util.errorLog('UserStore.login: http err:', err, body);
    } else if (body && body.player_session_key) {
      const { player_session_key, ...other } = body;
      g_sessionKey = player_session_key;
      window.localStorage[SESSION_KEY] = player_session_key;

      g_playerData = other;
    } else {
      g_playerData = body;
    }
    if (!err) {
      Analytics.addUserTag(g_playerData.player_id);
      g_isLoggedIn = true;
      _emit('user_login', g_playerData);
    }
    done(err);
  });
}

function get(opts, done) {
  _request(opts, 'GET', done);
}
function post(opts, done) {
  _request(opts, 'POST', done);
}
function del(opts, done) {
  _request(opts, 'DELETE', done);
}
function _request(opts, method, done) {
  if (typeof opts === 'string') {
    opts = {
      url: opts,
    };
  }
  opts.method = method;
  if (!opts.query) {
    opts.query = {};
  }
  opts.query['player_session_key'] = g_sessionKey;
  opts.force_text = true;
  Api.request(opts, done);
}
